import createIcon from '../../createIcon';

/**
 * @component @name EightkPlus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41IDEyLjVIOFYxNEg2LjVWMTIuNVpNNi41IDEwSDhWMTEuNUg2LjVWMTBaTTE5IDNINUMzLjkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY1QzIxIDMuOSAyMC4xIDMgMTkgM1pNOS41IDE0QzkuNSAxNC41NSA5LjA1IDE1IDguNSAxNUg2QzUuNDUgMTUgNSAxNC41NSA1IDE0VjEwQzUgOS40NSA1LjQ1IDkgNiA5SDguNUM5LjA1IDkgOS41IDkuNDUgOS41IDEwVjE0Wk0xNiAxNUgxNC4yNUwxMi41IDEyLjc1VjE1SDExVjlIMTIuNVYxMS4yNUwxNC4yNSA5SDE2TDEzLjc1IDEyTDE2IDE1Wk0yMCAxMi41SDE4LjVWMTRIMTcuNVYxMi41SDE2VjExLjVIMTcuNVYxMEgxOC41VjExLjVIMjBWMTIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EightkPlus = createIcon('EightkPlus', [
  [
    'path',
    {
      d: 'M6.5 12.5H8V14H6.5V12.5ZM6.5 10H8V11.5H6.5V10ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9.5 14C9.5 14.55 9.05 15 8.5 15H6C5.45 15 5 14.55 5 14V10C5 9.45 5.45 9 6 9H8.5C9.05 9 9.5 9.45 9.5 10V14ZM16 15H14.25L12.5 12.75V15H11V9H12.5V11.25L14.25 9H16L13.75 12L16 15ZM20 12.5H18.5V14H17.5V12.5H16V11.5H17.5V10H18.5V11.5H20V12.5Z',
      key: '1tv78a',
    },
  ],
]);

export default EightkPlus;
